import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";

const alertState = (state: RootState) => state.alert;

export const getAlertsList = createSelector(
  alertState,
  (alert) => ({
    loading: alert.listLoading,
    data: alert.alert.data,
    pagination: alert.alert.pagination,
  })
);

export const getSingleAlertDetail = createSelector(
  alertState,
  (alert) => {
    return {
      data: alert.alertById,
      singleLoading: alert.singleLoading
    };
  }
);